import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/aWBj8QxsESHbYa4DnrHtsC/Mauro_y_Omar_1.jpg', 'https://cdn.magicpatterns.com/uploads/8e13ohpR3Zntjaykmsn3RV/Mauro_y_Omar_2.png'];
export function ByeByeAdminPage() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <div className="min-h-screen bg-white flex items-center justify-center p-4" data-id="element-627">
      <div className="relative w-full max-w-2xl aspect-[3/4] overflow-hidden rounded-2xl shadow-2xl" data-id="element-628">
        <AnimatePresence mode="wait" data-id="element-629">
          <motion.img key={currentIndex} src={images[currentIndex]} alt="Mauro y Omar" className="absolute inset-0 w-full h-full object-cover" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeInOut'
        }} data-id="element-630" />
        </AnimatePresence>
      </div>
    </div>;
}